import { View } from "tamagui";
import { CardFlip } from "../../../components/CardFlip";
import { ProfileCard } from "../../../components/ProfileCard";
import { CardBack } from "../../../components/icons/CardBack";
import { useAtomValue } from "jotai";
import { currentUserAtom } from "../../../../atoms/global";
import { Loader } from "../../../components/design-system/Loader";
import { useApiQuery } from "../../../../lib/api";
import type { Profile } from "../../../types/profile";
import { useIsFocused } from "@react-navigation/native";
import { useEffect, useState } from "react";

export const ProfileCardFlip = () => {
  const currentUser = useAtomValue(currentUserAtom);
  const isFocused = useIsFocused();
  const [hasFlipped, setHasFlipped] = useState(false);

  const { data, isLoading } = useApiQuery<{ profile: Profile }>(
    ["profile", currentUser?.id],
    `/api/v1/profiles/${currentUser?.id}`,
    { enabled: !!currentUser?.id }
  );

  const profile = data?.profile ?? null;

  useEffect(() => {
    if (isFocused && profile && !hasFlipped) {
      const timer = setTimeout(() => {
        setHasFlipped(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isFocused, profile, hasFlipped]);

  if (isLoading) return <Loader />;

  return (
    <CardFlip
      front={
        <View
          flex={1}
          w="100%"
          bg="#3d3832"
          justifyContent="center"
          alignItems="center"
          borderRadius={12}
        >
          <CardBack width="60%" height="60%" />
        </View>
      }
      back={
        <View flex={1} w="100%">
          <ProfileCard profile={profile} />
        </View>
      }
      flipped={hasFlipped}
    />
  );
};
